import { Pipe, PipeTransform } from '@angular/core';
import { Icons } from '@app/shared/utils/icons';

@Pipe({
  standalone: true,
  name: 'tiIconGetColor',
})
export class IconGetColorPipe implements PipeTransform {
  transform(fileName: string, fullMatch: boolean = true): string {
    return Icons.getColorByFileType(fileName, fullMatch);
  }
}

@Pipe({
  standalone: true,
  name: 'tiIconGetClass',
})
export class IconGetClassPipe implements PipeTransform {
  transform(fileName: string, fullMatch: boolean = true): Icons.ByFileType {
    return Icons.getClassByFileType(fileName, fullMatch);
  }
}
